import * as yup from "yup";

export const ScreenSetupSetupValidationSchema = yup.object().shape({
  name: yup.string().required("Screen Name is required"),
  url: yup.string().required("Screen URL is required"),
  menuOrder: yup.string().required("Screen Sequence is required"),
});
